import { render, staticRenderFns } from "./rejectDialogV2.vue?vue&type=template&id=73b081d6&scoped=true"
import script from "./rejectDialogV2.vue?vue&type=script&lang=js"
export * from "./rejectDialogV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b081d6",
  null
  
)

export default component.exports